module.exports = __webpack_public_path__ + "static/og-image-school-a4c0c69e04343fff76b54f1e04d7e36f.jpg";